// There is no exposed toggle API from maplibre, so using the internal method from here:
// https://github.com/maplibre/maplibre-gl-js/blob/87486a5ef2085e600e8fa4e31252629dd8488dcd/src/ui/control/attribution_control.ts#L107
export const collapseAttributionControl = (map: HTMLElement | void) => {
    if (map) {
        const attributionElement = map.querySelector?.(".maplibregl-ctrl.maplibregl-ctrl-attrib");
        if (attributionElement) {
            attributionElement.removeAttribute('open');
            attributionElement.classList.remove('maplibregl-compact-show');
        }
    }
};